<template>
    <div v-if="report.employee_name?.length && report.employee_name !== 'Admin1'">
        <h1 class="m-1">{{ report.employee_name }} <small>{{ report.employee_username }}</small></h1>
    </div>


    <!-- Daily Attendance Actions -->
    <div class="daily-attendance" style="background: #f8f9fa; border: 2px solid #007bff; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div class="p-grid">
            <div class="p-col-6">
                <h3 style="margin: 0 0 10px 0; color: #007bff;">
                    <i class="pi pi-clock mr-2"></i>Daily Attendance
                </h3>
                <div v-if="report.is_checked_in" style="color: #28a745;">
                    <strong>✓ Checked In</strong>
                    <div v-if="report.check_in_time">at {{ formatCheckInTime(report.check_in_time) }}</div>
                    <div v-if="report.check_in_time">Duration: {{ getCurrentDuration() }}</div>
                </div>
                <div v-else style="color: #6c757d;">
                    <strong>⏰ Not Checked In</strong>
                    <div>Click Check In to start your day</div>
                </div>
            </div>
            <div class="p-col-6" style="text-align: right; display: flex; align-items: center; justify-content: flex-end; gap: 10px;">
                <p-button
                    label="Check In"
                    icon="pi pi-sign-in"
                    class="p-button-success"
                    @click="doCheckIn"
                    :loading="attendanceLoading"
                    :disabled="report.is_checked_in"
                />
                <p-button
                    label="Check Out"
                    icon="pi pi-sign-out"
                    class="p-button-danger"
                    @click="doCheckOut"
                    :loading="attendanceLoading"
                    :disabled="!report.is_checked_in"
                />
            </div>
        </div>
    </div>

    <div style="margin:0;" class="p-fluid p-grid p-formgrid">
        <div style="text-align:left;" class="p-field p-col-12 p-md-4">
          <label v-if="report.ranking">
            Ranking
          </label>
          <h1 class="m-0" v-if="report.ranking"><b>{{ getOrdinalSuffix(report.ranking) }}</b></h1>
          <hr/>
          <label>
            This Month's Target
          </label>
          <h1 class="m-0"><b>{{ formatToIndianNotation(report.targets?.thisMonthTarget?.amount || 0) }}</b></h1>
          <hr/>
          <label>
           Ytd Target
          </label>
          <h1 class="m-0"><b>{{ formatToIndianNotation(report.targets?.ytdTarget?.amount || 0) }}</b></h1>  
           
        </div>

        <div  class="p-field bg-gray-200 p-col-12 p-md-8">
         
          <p-chart 
          style="height:400px;" 
          type="line" 
          :data="report.lineChartData" 
          :options="lineChartOptions" />
          <h4 class="text-left"><b>Performance by Day</b></h4>
          <hr/>
        </div>
      </div>

      <small class="m-3">Overall Performance</small>
      <div style="margin:0;" class="p-fluid p-grid p-formgrid">
        <div style="text-align:left;" class="p-field p-col-12 p-md-3">
            <label>Leads Generated</label>
            <h1 class="m-1">{{ ((report.mtdPerformance?.leadsGenerated || 0) + (dashboard?.newLead || 0))?.toLocaleString() }} 
                <small v-if="!hide_plus && dashboard?.newLead" class="change-indicator">+{{ dashboard.newLead?.toLocaleString() }}</small>
            </h1>
        </div>
        <div style="text-align:left;" class="p-field p-col-12 p-md-3">
            <label>Converted Leads</label>
            <h1 class="m-1">{{ ((report.mtdPerformance?.convertedLeads || 0) + (dashboard?.convertLead || 0))?.toLocaleString() }}
                <small v-if="!hide_plus && dashboard?.convertLead" class="change-indicator">+{{ dashboard.convertLead?.toLocaleString() }}</small>
            </h1>
        </div>
        <div style="text-align:left;" class="p-field p-col-12 p-md-3">
            <label>Revenue Generated</label>
            <h1 class="m-1">{{ formatToIndianNotation((report.mtdPerformance?.revenueGenerated || 0) + (dashboard?.revenueGenerated || 0)) }}
                <small v-if="!hide_plus && dashboard?.revenueGenerated" class="change-indicator">+{{ dashboard.revenueGenerated?.toLocaleString() }}</small>
            </h1>
        </div>
        <div style="text-align:left;" class="p-field p-col-12 p-md-3">
            <label>New Customers</label>
            <h1 class="m-1">{{ ((report.mtdPerformance?.newCustomers || 0) + (dashboard?.newCustomer || 0))?.toLocaleString() }}
                <small v-if="!hide_plus && dashboard?.newCustomer" class="change-indicator">+{{ dashboard.newCustomer?.toLocaleString() }}</small>
            </h1>
        </div>

      </div>
  </template>
  
  <script lang="ts">
  import { base, formatToIndianNotation } from "@/misc/base";
  import { Options } from 'vue-class-component';
  import { mapState } from 'vuex';
  import { State } from '../store/index';
  
  import 'chartjs-adapter-moment';

  @Options({
    components: {},
    props: {
        report: Object,
        hide_plus: Boolean,
    },
    computed: {
        ...mapState<State>({
            // eslint-disable-next-line
            dashboard: (state : State ) => state.dashboard // Mapping the ws state to a computed property
        })
    },
  })
  export default class DSEDashboard extends base {
  
    report! : any
    hide_plus! : boolean
    dashboard! : any
    attendanceLoading = false


    formatToIndianNotation = formatToIndianNotation
  
    chartOptions =  {
        plugins: {
            legend: {
                labels: {
                    cutout: '60%',
                    color: "#333",
                }
            }
        }
    }
  
    lineChartOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
            legend: {
                labels: {
                    color: "#333"
                }
            }
        },
        scales: {
            x: {
                type: 'time',
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Date'
                },
            },
        }
    }
  
    lineChartData : any = null
    chartData : any = null
    
    getOrdinalSuffix(number: number) {
        const suffixes = ["th", "st", "nd", "rd"];
        const remainderTen = number % 10;
        const remainderHundred = number % 100;

        // Handle special cases like 11th, 12th, 13th
        if (remainderHundred >= 11 && remainderHundred <= 13) {
            return number + "th";
        }

        // Assign correct suffix based on the remainder when dividing by 10
        const suffix = suffixes[remainderTen] || suffixes[0];
        return number + suffix;
    }

    // Attendance functionality methods
    formatCheckInTime(timeString: string): string {
        try {
            const date = new Date(timeString);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        } catch (error) {
            return timeString;
        }
    }

    getCurrentDuration(): string {
        if (!this.report.check_in_time) return '';

        try {
            const checkInTime = new Date(this.report.check_in_time);
            const now = new Date();
            const diffMs = now.getTime() - checkInTime.getTime();

            const hours = Math.floor(diffMs / (1000 * 60 * 60));
            const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

            return `${hours}h ${minutes}m`;
        } catch (error) {
            return '';
        }
    }

    async doCheckIn() {
        if (this.attendanceLoading) return;

        this.attendanceLoading = true;

        try {
            // Get current location for check-in
            const location = await this.getCurrentLocation();

            const simforce = this.store.state.simforce;

            const payload = {
                latitude: location.latitude,
                longitude: location.longitude,
                timestamp: new Date().toISOString()
            };

            const response = await simforce.post('/checkin', payload);

            if (response.status === 200) {
                // Update status immediately
                this.report.is_checked_in = true;
                this.report.check_in_time = new Date().toISOString();

                this.$toast.add({
                    severity: 'success',
                    summary: 'Checked In',
                    detail: 'Successfully checked in for today',
                    life: 3000
                });

                // Refresh dashboard data
                this.$emit('attendance-changed');

            } else {
                throw new Error('Check-in failed');
            }

        } catch (error) {
            console.error('Check-in error:', error);

            this.$toast.add({
                severity: 'error',
                summary: 'Check-in Failed',
                detail: 'Failed to check in. Please try again.',
                life: 3000
            });
        } finally {
            this.attendanceLoading = false;
        }
    }

    async doCheckOut() {
        if (this.attendanceLoading) return;

        this.attendanceLoading = true;

        try {
            // Get current location for check-out
            const location = await this.getCurrentLocation();

            const simforce = this.store.state.simforce;

            const payload = {
                latitude: location.latitude,
                longitude: location.longitude,
                timestamp: new Date().toISOString()
            };

            const response = await simforce.post('/checkout', payload);

            if (response.status === 200) {
                // Update status immediately
                this.report.is_checked_in = false;
                this.report.check_in_time = null;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Checked Out',
                    detail: 'Successfully checked out for today',
                    life: 3000
                });

                // Refresh dashboard data
                this.$emit('attendance-changed');

            } else {
                throw new Error('Check-out failed');
            }

        } catch (error) {
            console.error('Check-out error:', error);

            this.$toast.add({
                severity: 'error',
                summary: 'Check-out Failed',
                detail: 'Failed to check out. Please try again.',
                life: 3000
            });
        } finally {
            this.attendanceLoading = false;
        }
    }

    async getCurrentLocation(): Promise<{ latitude: number; longitude: number }> {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error('Geolocation not supported'));
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                },
                (error) => {
                    reject(new Error(`Location error: ${error.message}`));
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 300000 // 5 minutes
                }
            );
        });
    }

  }
  </script>

<style scoped>
.attendance-status {
  margin: 20px 0;
}

.status-display {
  display: flex;
  align-items: center;
  gap: 15px;
}

.status-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  transition: all 0.3s ease;
}

.status-icon.checked-in {
  background: rgba(40, 167, 69, 0.3);
  border: 2px solid #28a745;
  color: #28a745;
}

.status-icon.checked-out {
  background: rgba(255, 193, 7, 0.3);
  border: 2px solid #ffc107;
  color: #ffc107;
}

.status-info h3 {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.status-info p {
  margin: 0;
  opacity: 0.9;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.attendance-actions {
  margin-bottom: 8px;
}

.duration-info {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .attendance-status .p-grid {
    flex-direction: column;
    gap: 15px;
  }

  .attendance-status .p-col-6:last-child {
    text-align: left !important;
  }

  .status-display {
    justify-content: center;
  }

  .attendance-actions {
    text-align: center;
  }
}
</style>

<!-- {
  "employee_name": "",
  "employee_username": ""
}-->